module.exports = __webpack_public_path__ + "img/sndle-avatar-male.c1babce2.png";